webpackJsonp([44],{

/***/ 1066:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_new_form_commitees_vue__ = __webpack_require__(1596);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7cbdc44_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_new_form_commitees_vue__ = __webpack_require__(2077);
function injectStyle (ssrContext) {
  __webpack_require__(2075)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d7cbdc44"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_new_form_commitees_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7cbdc44_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_new_form_commitees_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1084:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function color() {
	if (this.primary && !this.bgColor) {
		return this.$appColors.primary;
	}
	return this.bgColor;
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-button',
	computed: {
		color: color
	},
	props: {
		bgColor: {
			default: '',
			type: String
		},
		img: {
			default: '',
			type: String
		},
		icon: {
			default: '',
			type: String
		},
		iconAfter: {
			default: false,
			type: Boolean
		},
		iconColor: {
			default: 'white',
			type: String
		},
		primary: {
			type: Boolean,
			default: true
		},
		text: {
			default: '',
			type: String
		}
	}
});

/***/ }),

/***/ 1085:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_button_vue__ = __webpack_require__(1084);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c2b9ed8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_button_vue__ = __webpack_require__(1088);
function injectStyle (ssrContext) {
  __webpack_require__(1086)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c2b9ed8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c2b9ed8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1086:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1087);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1025)("252359ba", content, true, {});

/***/ }),

/***/ 1087:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1024)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroT;src:url(\"/static/fonts/NeuzeitGroT.eot\");src:url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBold;src:url(\"/static/fonts/NeuzeitGroTBold.eot\");src:url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTLig;src:url(\"/static/fonts/NeuzeitGroLig.eot\");src:url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBla;src:url(\"/static/fonts/NeuzeitGroTBla.eot\");src:url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");font-weight:400;font-style:normal}.button-container[data-v-6c2b9ed8]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-transition:all .25s ease-in;transition:all .25s ease-in}.button-container.img-center[data-v-6c2b9ed8]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.button-container.img-after[data-v-6c2b9ed8]{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.button-container.img-before[data-v-6c2b9ed8]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.button-container[data-v-6c2b9ed8]:hover{-webkit-filter:brightness(1.2);filter:brightness(1.2)}.button-container[data-v-6c2b9ed8]:active{-webkit-transform:scale(.95,.98);transform:scale(.95,.98)}.button-container[disabled][data-v-6c2b9ed8]{background-color:#a3a3a3!important;cursor:not-allowed;opacity:.4}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/app-button.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,yCAA0C,AAC1C,iHAAmH,AACnH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,4BAA+B,AAC/B,6CAA8C,AAC9C,yHAA2H,AAC3H,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,2CAA4C,AAC5C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,4CAA6C,AAC7C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,mCACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,uBAAwB,AACpB,oBAAqB,AACjB,2BAA4B,AACpC,oCAAsC,AACtC,2BAA8B,CAC/B,AACD,8CACI,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACnC,AACD,6CACI,8BAA+B,AAC/B,8BAA+B,AAC3B,+BAAgC,AAC5B,0BAA4B,CACvC,AACD,8CACI,8BAA+B,AAC/B,6BAA8B,AAC1B,uBAAwB,AACpB,kBAAoB,CAC/B,AACD,yCACI,+BAAgC,AACxB,sBAAwB,CACnC,AACD,0CACI,iCAAqC,AAC7B,wBAA6B,CACxC,AACD,6CACI,mCAAqC,AACrC,mBAAoB,AACpB,UAAa,CAChB","file":"app-button.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroT';\n  src: url(\"/static/fonts/NeuzeitGroT.eot\");\n  src: url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBold';\n  src: url(\"/static/fonts/NeuzeitGroTBold.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTLig';\n  src: url(\"/static/fonts/NeuzeitGroLig.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBla';\n  src: url(\"/static/fonts/NeuzeitGroTBla.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n.button-container[data-v-6c2b9ed8] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  -webkit-transition: all 250ms ease-in;\n  transition: all 250ms ease-in;\n}\n.button-container.img-center[data-v-6c2b9ed8] {\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.button-container.img-after[data-v-6c2b9ed8] {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: reverse;\n        -ms-flex-direction: row-reverse;\n            flex-direction: row-reverse;\n}\n.button-container.img-before[data-v-6c2b9ed8] {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n            flex-direction: row;\n}\n.button-container[data-v-6c2b9ed8]:hover {\n    -webkit-filter: brightness(1.2);\n            filter: brightness(1.2);\n}\n.button-container[data-v-6c2b9ed8]:active {\n    -webkit-transform: scale(0.95, 0.98);\n            transform: scale(0.95, 0.98);\n}\n.button-container[disabled][data-v-6c2b9ed8] {\n    background-color: #a3a3a3 !important;\n    cursor: not-allowed;\n    opacity: 0.4;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1088:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
		'button-container',
		_vm.iconAfter ? 'img-after': 'img-before',
		{ 'img-center': !_vm.text } ],style:(("background-color:" + _vm.color)),attrs:{"type":"button"},on:{"click":function($event){_vm.$emit('click')}}},[(_vm.img)?_c('img',{attrs:{"src":_vm.img}}):_vm._e(),_vm._v(" "),(_vm.icon)?_c('v-icon',{attrs:{"color":_vm.iconColor}},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._v(" "),(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1596:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_app_button__ = __webpack_require__(1085);




var loadEditCommitee = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(id) {
		var response, _response$data, name, stalls, jobs;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return this.$httpPraktiko.get('groups/' + id);

					case 2:
						response = _context.sent;
						_response$data = response.data, name = _response$data.name, stalls = _response$data.stalls, jobs = _response$data.jobs;

						this.newCommitee.name = name;
						this.newCommitee.stalls = stalls;
						this.newCommitee.jobs = jobs;

					case 7:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function loadEditCommitee(_x) {
		return _ref.apply(this, arguments);
	};
}();

var loadStalls = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var params, response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						params = {
							typeGroup: 2
						};
						_context2.next = 3;
						return this.$httpPraktiko.get('groups', { params: params });

					case 3:
						response = _context2.sent;

						this.stalls = response.data;

					case 5:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function loadStalls() {
		return _ref2.apply(this, arguments);
	};
}();

var loadEmployees = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var _ref4, response;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						_context3.next = 2;
						return this.$httpPraktiko.get('employee');

					case 2:
						_ref4 = _context3.sent;
						response = _ref4.data;

						this.members = response;

					case 5:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	return function loadEmployees() {
		return _ref3.apply(this, arguments);
	};
}();

var createCommitee = function () {
	var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
		var body;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						body = {
							name: this.newCommitee.name,
							code: this.newCommitee.name.replace(/ /g, '-'),
							jobs: this.newCommitee.jobs.map(function (p) {
								return p.id;
							}),
							employees: this.newCommitee.stalls.map(function (q) {
								return q.id;
							})
						};
						_context4.prev = 1;
						_context4.next = 4;
						return this.$httpPraktiko.post('groups', body);

					case 4:
						this.showNotification('El comité se creó correctamente.');
						this.goTo('job-evaluation-processes-commitees');
						_context4.next = 11;
						break;

					case 8:
						_context4.prev = 8;
						_context4.t0 = _context4['catch'](1);

						this.showGenericError();

					case 11:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, this, [[1, 8]]);
	}));

	return function createCommitee() {
		return _ref5.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function created() {
	var id = this.$route.params.id;

	this.idCommitee = id;
	if (id) {
		this.loadEditCommitee(id);
	}
	this.loadStalls();
	this.loadEmployees();
}

function formTitle() {
	return this.idCommitee ? 'Editar Comité' : this.$route.meta.title;
}

function flagEdit(flag) {
	if (flag) {
		this.newCommitee = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.editingData);
	}
}

function addEmployees() {
	var _newCommitee$employee = this.newCommitee.employee,
	    name = _newCommitee$employee.name,
	    id = _newCommitee$employee.id;

	this.newCommitee.stalls.push({ name: name, id: id });
	this.newCommitee.employee = null;
}

function addJobs() {
	var _newCommitee$job = this.newCommitee.job,
	    name = _newCommitee$job.name,
	    id = _newCommitee$job.id;

	this.newCommitee.jobs.push({ name: name, id: id });
	this.newCommitee.job = null;
}

function goBack() {
	this.$router.back();
}

function deleteStalls(index) {
	this.newCommitee.stalls.splice(index, 1);
}

function deleteJobs(index) {
	this.newCommitee.jobs.splice(index, 1);
}

function data() {
	return {
		idCommitee: null,
		members: [],
		newCommitee: {
			name: '',
			job: null,
			stalls: [],
			jobs: []
		},
		stalls: []
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'new-form-commitees',
	created: created,
	components: {
		appButton: __WEBPACK_IMPORTED_MODULE_3__components_shared_app_button__["a" /* default */]
	},
	computed: {
		formTitle: formTitle
	},
	methods: {
		addEmployees: addEmployees,
		addJobs: addJobs,
		createCommitee: createCommitee,
		deleteJobs: deleteJobs,
		deleteStalls: deleteStalls,
		goBack: goBack,
		loadEditCommitee: loadEditCommitee,
		loadEmployees: loadEmployees,
		loadStalls: loadStalls
	},
	watch: {
		flagEdit: flagEdit
	},
	data: data
});

/***/ }),

/***/ 2075:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2076);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1025)("c89f1ca8", content, true, {});

/***/ }),

/***/ 2076:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1024)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroT;src:url(\"/static/fonts/NeuzeitGroT.eot\");src:url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBold;src:url(\"/static/fonts/NeuzeitGroTBold.eot\");src:url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTLig;src:url(\"/static/fonts/NeuzeitGroLig.eot\");src:url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBla;src:url(\"/static/fonts/NeuzeitGroTBla.eot\");src:url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");font-weight:400;font-style:normal}.new-tool-form[data-v-d7cbdc44]{background-color:#fff;border:1px solid #e9e9e9;-webkit-box-shadow:0 2px 7px 0 rgba(0,0,0,.2);box-shadow:0 2px 7px 0 rgba(0,0,0,.2);margin-bottom:21px;padding:44px 0}.new-tool-form .new-tool-form-title[data-v-d7cbdc44]{font-family:NeuzeitGroTBold;font-size:18px;margin-bottom:22px;padding:0 33px 12px}.new-tool-form label[data-v-d7cbdc44]{font-size:12px}.new-tool-form label input[data-v-d7cbdc44]::-webkit-input-placeholder{font-size:14px}.new-tool-form label input[data-v-d7cbdc44]::-moz-placeholder{font-size:14px}.new-tool-form label input[data-v-d7cbdc44]::-ms-input-placeholder{font-size:14px}.new-tool-form label input[data-v-d7cbdc44]::placeholder{font-size:14px}.new-tool-form .form[data-v-d7cbdc44]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;display:-webkit-box;display:-ms-flexbox;display:flex;padding:0 38px}.new-tool-form .form .general-section[data-v-d7cbdc44],.new-tool-form .form .media-section[data-v-d7cbdc44]{-ms-flex-preferred-size:50%;flex-basis:50%}.new-tool-form .form .w-100[data-v-d7cbdc44]{width:100%!important}.form-header[data-v-d7cbdc44]{padding:0 38px}.number-process[data-v-d7cbdc44]{background-color:#55ac4b;border-radius:50%;height:33px;font-size:18px;padding-top:2px;width:33px}.w-100[data-v-d7cbdc44]{width:100%}.container-search[data-v-d7cbdc44]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.video-label[data-v-d7cbdc44]{-ms-flex-preferred-size:89%;flex-basis:89%}.section-title[data-v-d7cbdc44]{color:#545a54}.img-link-container[data-v-d7cbdc44],.video-link-container[data-v-d7cbdc44]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border:1px solid #cdcdcd;padding:0 15px 0 26px;width:100%}.video-btn[data-v-d7cbdc44]{border-radius:3px!important;height:25px!important;width:25px}.label-commitees[data-v-d7cbdc44]{border:1px solid rgba(0,0,0,.12);border-radius:4px;-webkit-box-shadow:0 0 4px 0 rgba(0,0,0,.12);box-shadow:0 0 4px 0 rgba(0,0,0,.12);font-size:12px;padding:9px 21px}", "", {"version":3,"sources":["/opt/build/repo/src/modules/job-evaluation/pages/commitees/new-form-commitees.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,yCAA0C,AAC1C,iHAAmH,AACnH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,4BAA+B,AAC/B,6CAA8C,AAC9C,yHAA2H,AAC3H,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,2CAA4C,AAC5C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,4CAA6C,AAC7C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,gCACE,sBAAwB,AACxB,yBAA0B,AAC1B,8CAAmD,AAC3C,sCAA2C,AACnD,mBAAoB,AACpB,cAAgB,CACjB,AACD,qDACI,4BAA+B,AAC/B,eAAgB,AAChB,mBAAoB,AACpB,mBAAqB,CACxB,AACD,sCACI,cAAgB,CACnB,AACD,uEACM,cAAgB,CACrB,AACD,8DACM,cAAgB,CACrB,AACD,mEACM,cAAgB,CACrB,AACD,yDACM,cAAgB,CACrB,AACD,sCACI,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,cAAgB,CACnB,AACD,4GACM,4BAA6B,AACzB,cAAgB,CACzB,AACD,6CACM,oBAAuB,CAC5B,AACD,8BACE,cAAgB,CACjB,AACD,iCACE,yBAA0B,AAC1B,kBAAmB,AACnB,YAAa,AACb,eAAgB,AAChB,gBAAiB,AACjB,UAAY,CACb,AACD,wBACE,UAAY,CACb,AACD,mCACE,sBAAuB,AACnB,mBAAoB,AAChB,qBAAsB,AAC9B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,cAAgB,CACrB,AACD,8BACE,4BAA6B,AACzB,cAAgB,CACrB,AACD,gCACE,aAAe,CAChB,AACD,4EACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,yBAA0B,AAC1B,sBAAuB,AACvB,UAAY,CACb,AACD,4BACE,4BAA8B,AAC9B,sBAAwB,AACxB,UAAY,CACb,AACD,kCACE,iCAAsC,AACtC,kBAAmB,AACnB,6CAAkD,AAC1C,qCAA0C,AAClD,eAAgB,AAChB,gBAAkB,CACnB","file":"new-form-commitees.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroT';\n  src: url(\"/static/fonts/NeuzeitGroT.eot\");\n  src: url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBold';\n  src: url(\"/static/fonts/NeuzeitGroTBold.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTLig';\n  src: url(\"/static/fonts/NeuzeitGroLig.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBla';\n  src: url(\"/static/fonts/NeuzeitGroTBla.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n.new-tool-form[data-v-d7cbdc44] {\n  background-color: white;\n  border: 1px solid #e9e9e9;\n  -webkit-box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.2);\n          box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.2);\n  margin-bottom: 21px;\n  padding: 44px 0;\n}\n.new-tool-form .new-tool-form-title[data-v-d7cbdc44] {\n    font-family: \"NeuzeitGroTBold\";\n    font-size: 18px;\n    margin-bottom: 22px;\n    padding: 0 33px 12px;\n}\n.new-tool-form label[data-v-d7cbdc44] {\n    font-size: 12px;\n}\n.new-tool-form label input[data-v-d7cbdc44]::-webkit-input-placeholder {\n      font-size: 14px;\n}\n.new-tool-form label input[data-v-d7cbdc44]::-moz-placeholder {\n      font-size: 14px;\n}\n.new-tool-form label input[data-v-d7cbdc44]::-ms-input-placeholder {\n      font-size: 14px;\n}\n.new-tool-form label input[data-v-d7cbdc44]::placeholder {\n      font-size: 14px;\n}\n.new-tool-form .form[data-v-d7cbdc44] {\n    -webkit-box-align: start;\n        -ms-flex-align: start;\n            align-items: flex-start;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    padding: 0 38px;\n}\n.new-tool-form .form .general-section[data-v-d7cbdc44], .new-tool-form .form .media-section[data-v-d7cbdc44] {\n      -ms-flex-preferred-size: 50%;\n          flex-basis: 50%;\n}\n.new-tool-form .form .w-100[data-v-d7cbdc44] {\n      width: 100% !important;\n}\n.form-header[data-v-d7cbdc44] {\n  padding: 0 38px;\n}\n.number-process[data-v-d7cbdc44] {\n  background-color: #55ac4b;\n  border-radius: 50%;\n  height: 33px;\n  font-size: 18px;\n  padding-top: 2px;\n  width: 33px;\n}\n.w-100[data-v-d7cbdc44] {\n  width: 100%;\n}\n.container-search[data-v-d7cbdc44] {\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.video-label[data-v-d7cbdc44] {\n  -ms-flex-preferred-size: 89%;\n      flex-basis: 89%;\n}\n.section-title[data-v-d7cbdc44] {\n  color: #545a54;\n}\n.img-link-container[data-v-d7cbdc44], .video-link-container[data-v-d7cbdc44] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  border: 1px solid #cdcdcd;\n  padding: 0 15px 0 26px;\n  width: 100%;\n}\n.video-btn[data-v-d7cbdc44] {\n  border-radius: 3px !important;\n  height: 25px !important;\n  width: 25px;\n}\n.label-commitees[data-v-d7cbdc44] {\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  border-radius: 4px;\n  -webkit-box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.12);\n          box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.12);\n  font-size: 12px;\n  padding: 9px 21px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2077:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-tool-form"},[_c('form',[_c('div',{staticClass:"form-header"},[_c('section',[_c('div',{staticClass:"tw-flex"},[_c('div',{staticClass:"number-process font-weight-bold tw-text-center text-white"},[_vm._v("\n\t\t\t\t\t\t1\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"ml-3 w-100"},[_c('h3',{staticClass:"section-title font-weight-bold mb-3 pb-2",style:(("border-bottom:1px solid " + (_vm.$appColors.gray)))},[_vm._v("NOMBRE DE COMITE")])])]),_vm._v(" "),_c('div',{staticClass:"code mt-3"},[_c('label',{style:(("color:" + (_vm.$appColors.info))),attrs:{"for":"new-tool-code"}},[_vm._v("\n\t\t\t\t\t\tNombre de Comité\n\t\t\t\t\t\t"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newCommitee.name),expression:"newCommitee.name"}],staticClass:"new-survey-input",attrs:{"id":"new-tool-code","placeholder":"Código"},domProps:{"value":(_vm.newCommitee.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newCommitee, "name", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"form mt-4"},[_c('section',{staticClass:"general-section"},[_c('div',{staticClass:"tw-flex"},[_c('div',{staticClass:"number-process font-weight-bold tw-text-center text-white"},[_vm._v("\n\t\t\t\t\t\t2\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"ml-3"},[_c('h3',{staticClass:"section-title font-weight-bold mb-3 pb-2",style:(("border-bottom:1px solid " + (_vm.$appColors.gray)))},[_vm._v("SELECCIONAR PUESTOS A VALORAR")])])]),_vm._v(" "),_c('div',{staticClass:"label-commitees mb-2"},[_vm._v("\n\t\t\t\t\tSeleccionar las personas encargadas de valorar los puestos\n\t\t\t\t")]),_vm._v(" "),_c('label',{style:(("color:" + (_vm.$appColors.primary) + ";"))},[_vm._v("AGREGA PUESTOS")]),_vm._v(" "),_c('div',{staticClass:"container-search mt-2"},[_c('label',{staticClass:"video-label",style:(("color:" + (_vm.$appColors.info)))},[_vm._v("\n\t\t\t\t\t\tBuscar Puestos\n\t\t\t\t\t\t"),_c('v-autocomplete',{staticClass:"autocomplete-select",attrs:{"dense":"","background-color":"white","box":"","height":37,"append-icon":"search","autocomplete":"","return-object":"","items":_vm.stalls,"item-text":"name","item-value":"id","hide-details":""},model:{value:(_vm.newCommitee.job),callback:function ($$v) {_vm.$set(_vm.newCommitee, "job", $$v)},expression:"newCommitee.job"}})],1),_vm._v(" "),_c('app-button',{staticClass:"video-btn ml-3",attrs:{"disabled":!_vm.newCommitee.job,"icon":"add"},on:{"click":_vm.addJobs}}),_vm._v(" "),_vm._l((_vm.newCommitee.jobs),function(item,indexVi){return _c('div',{key:indexVi,staticClass:"video-link-container mt-2"},[_c('div',{staticClass:"videos-link tw-flex tw-justify-between tw-items-center"},[_c('div',{style:(("color:" + (_vm.$appColors.info)))},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(item.name)+"\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('div',[_c('app-tooltip-button',{attrs:{"img":"https://s3.amazonaws.com/apprunn-acl/COM-PRU-01/ARQ88/image/delete-button-(1).svg","text":"Eliminar"},on:{"click-icon":function($event){_vm.deleteJobs(indexVi)}}})],1)])])})],2)]),_vm._v(" "),_c('section',{staticClass:"media-section ml-5"},[_c('div',{staticClass:"tw-flex"},[_c('div',{staticClass:"number-process font-weight-bold tw-text-center text-white"},[_vm._v("\n\t\t\t\t\t\t3\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"ml-3"},[_c('h3',{staticClass:"section-title font-weight-bold mb-3 pb-2",style:(("border-bottom:1px solid " + (_vm.$appColors.gray)))},[_vm._v("SELECCIONAR MIEMBROS DE COMITÉ")])])]),_vm._v(" "),_c('div',{staticClass:"label-commitees mb-2"},[_vm._v("\n\t\t\t\t\tSeleccionar las personas encargadas de valorar los puestos\n\t\t\t\t")]),_vm._v(" "),_c('label',{staticClass:"mt-2",style:(("color:" + (_vm.$appColors.primary) + ";"))},[_vm._v("AGREGAR MIEMBRO DE COMITÉ")]),_vm._v(" "),_c('div',{staticClass:"container-search mt-2"},[_c('label',{staticClass:"video-label",style:(("color:" + (_vm.$appColors.info)))},[_vm._v("\n\t\t\t\t\t\tBuscar Encargados\n\t\t\t\t\t\t"),_c('v-autocomplete',{staticClass:"autocomplete-select",attrs:{"background-color":"white","box":"","hide-details":"","append-icon":"search","autocomplete":"","return-object":"","items":_vm.members,"item-text":"name","item-value":"id"},model:{value:(_vm.newCommitee.employee),callback:function ($$v) {_vm.$set(_vm.newCommitee, "employee", $$v)},expression:"newCommitee.employee"}})],1),_vm._v(" "),_c('app-button',{staticClass:"video-btn ml-3",attrs:{"disabled":!_vm.newCommitee.employee,"icon":"add"},on:{"click":_vm.addEmployees}}),_vm._v(" "),_vm._l((_vm.newCommitee.stalls),function(item,indexVi){return _c('div',{key:indexVi,staticClass:"video-link-container mt-2"},[_c('div',{staticClass:"videos-link tw-flex tw-justify-between tw-items-center"},[_c('span',{style:(("color:" + (_vm.$appColors.info)))},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(item.name)+"\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('app-tooltip-button',{attrs:{"img":"https://s3.amazonaws.com/apprunn-acl/COM-PRU-01/ARQ88/image/delete-button-(1).svg","text":"Eliminar"},on:{"click-icon":function($event){_vm.deleteStalls(indexVi)}}})],1)])})],2)])])]),_vm._v(" "),_c('section',{staticClass:"modal-filter-footer"},[_c('modal-sidebar-button',{attrs:{"cancel-text":"Atras","success-color":"primary","success-text":"Guardar"},on:{"cancel-button-clicked":_vm.goBack,"accept-button-clicked":_vm.createCommitee}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/44.c268ccc8ba4ff5841738.js